import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components/macro';

import { Box } from '@olist/united';

export const CheckboxGroup = styled(Box).attrs({
  my: 3,
  py: 2,
  px: 3,
})`
  border: 1px solid ${themeGet('colors.shades.2')};
  border-radius: 8px;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RequiredField = styled.p`
  color: ${({ theme }) => theme.olist.color.alert.base};
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
`;

export const CustomSelect = styled.div`
  position: relative;

  svg {
    position: absolute;
    right: 16px;
    top: 40%;
  }
  select {
    -webkit-appearance: none;
    align-items: center;
    background-color: transparent;
    border: none;
    border-radius: 8px;
    box-shadow: none;
    box-sizing: border-box;
    color: #312f4f;
    display: flex;
    font-size: 16px;
    height: 48px;
    height: 100%;
    line-height: 24px;
    margin-top: 8px;
    outline: 1px solid #d1d1e3;
    padding: 16px 52px 16px 16px;
    width: 100%;

    &:focus {
      outline: 2px solid #0c29d0;
    }
  }

  .empty-option {
    font-style: italic;
  }
`;

export const CustomLabel = styled.label`
  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0px;
  }

  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0px;
  line-height: 20px;
  margin: 0 0 8px 0;
`;
